// Dashed polylines for fleet routes (GDD 08 "animated dashes"); Pixi 8 has no dashed stroke.
import type { Point } from './camera';

const lerp = (a: Point, b: Point, t: number): Point => ({
  x: a.x + (b.x - a.x) * t,
  y: a.y + (b.y - a.y) * t,
});

/** Dash pieces along a polyline: `dash` on, `gap` off, shifted forward by `offset` (path units). */
export function dashSegments(
  points: readonly Point[],
  dash: number,
  gap: number,
  offset = 0
): [Point, Point][] {
  const period = dash + gap;
  if (period <= 0 || dash <= 0 || points.length < 2) return [];
  const out: [Point, Point][] = [];
  let phase = ((-offset % period) + period) % period;
  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i] as Point;
    const b = points[i + 1] as Point;
    const length = Math.hypot(b.x - a.x, b.y - a.y);
    let s = 0;
    while (s < length) {
      const inDash = phase < dash;
      const step = Math.min(length - s, inDash ? dash - phase : period - phase);
      if (inDash) out.push([lerp(a, b, s / length), lerp(a, b, (s + step) / length)]);
      s += step;
      phase = (phase + step) % period;
    }
  }
  return out;
}
